import React from 'react';
import { Container, Typography, Grid, Box, Paper } from '@mui/material';
import { Phone, Email, LocationOn, Work } from '@mui/icons-material';
import '../styles/animations.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Phone color="primary" />,
      title: 'Phone',
      details: [
        '+91 123-456-7890',
        '+91 098-765-4321'
      ]
    },
    {
      icon: <Email color="primary" />,
      title: 'Email',
      details: [
        'info@4rootsrealty.com',
        'sales@4rootsrealty.com'
      ]
    },
    {
      icon: <LocationOn color="primary" />,
      title: 'Address',
      details: [
        '4 Roots Realty Office,',
        'Sector 15, Gurgaon,',
        'Haryana - 122001'
      ]
    }
  ];

  return (
    <Container sx={{ py: 8 }}>
      <Typography 
        variant="h2" 
        align="center" 
        gutterBottom
        className="animate-fadeInUp"
      >
        Contact Us
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        color="text.secondary" 
        paragraph
        className="animate-fadeInUp delay-100"
      >
        Get in touch with us for any queries
      </Typography>

      <Grid container spacing={4} sx={{ mt: 4 }}>
        {contactInfo.map((info, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Paper 
              elevation={3} 
              sx={{ p: 4, height: '100%', textAlign: 'center' }}
              className={`animate-scaleIn hover-scale delay-${index * 100}`}
            >
              <Box sx={{ mb: 2 }}>
                {React.cloneElement(info.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h5" gutterBottom>
                {info.title}
              </Typography>
              {info.details.map((detail, idx) => (
                <Typography key={idx} variant="body1" color="text.secondary">
                  {detail}
                </Typography>
              ))}
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Get in Touch Form */}
      <Box sx={{ mt: 12 }} className="animate-fadeInUp delay-200">
        <Typography variant="h3" align="center" gutterBottom>
          Get in Touch
        </Typography>
        <Box sx={{ mt: 4 }}>
          <iframe
            src="https://docs.google.com/forms/d/e/YOUR_CONTACT_FORM_ID/viewform?embedded=true"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
          >
            Loading…
          </iframe>
        </Box>
      </Box>

      {/* Work with Us Form */}
      <Box sx={{ mt: 8 }} className="animate-fadeInUp delay-300">
        <Typography variant="h3" align="center" gutterBottom>
          Work with Us
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Work sx={{ fontSize: 40, color: 'primary.main', mr: 2 }} />
          <Typography variant="h5" color="text.secondary">
            Join our growing team of real estate professionals
          </Typography>
        </Box>
        <Box sx={{ mt: 4 }}>
          <iframe
            src="https://docs.google.com/forms/d/e/YOUR_CAREERS_FORM_ID/viewform?embedded=true"
            width="100%"
            height="600"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
          >
            Loading…
          </iframe>
        </Box>
      </Box>

      {/* Map */}
      <Box sx={{ mt: 8 }} className="animate-fadeInUp delay-400">
        <Typography variant="h3" align="center" gutterBottom>
          Visit Us
        </Typography>
        <Box sx={{ mt: 4, height: 450 }}>
          <iframe
            src="https://www.google.com/maps/embed?pb=YOUR_MAP_EMBED_URL"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      </Box>
    </Container>
  );
};

export default Contact; 